<!--
 * @Description: 批次检测
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-09-24 14:07:05
-->
<template>
  <CommonCheckout :dataTypeId='2'/>
</template>

<script>
import CommonCheckout from './commoncheckout'
export default {
  components: {
    CommonCheckout
  },
};
</script>
